import { usePipelineConfig } from 'features/knowledgeDocumentViewer/contexts/PipelineConfigContext'
import { useGeckoPermissions } from 'features/permissions'
import styled from 'styled-components'
import { PERMISSION_GECKO_INTERNAL_MEMBER } from 'types'

import { DocumentPreviewModeSwitch } from './DocumentPreviewModeSwitch'
import { Toolbar, ToolbarAgentButtonSlot } from './documentTabsStyles'

const PreviewToolbar = styled(Toolbar)`
  justify-content: flex-end;
`

export function DocumentPreviewModeToolbar() {
  const { hasPreviewConfig } = usePipelineConfig()
  const { hasPermissions } = useGeckoPermissions()
  const canTogglePreview = hasPermissions([PERMISSION_GECKO_INTERNAL_MEMBER])

  if (!canTogglePreview || !hasPreviewConfig) {
    return null
  }

  return (
    <PreviewToolbar>
      <ToolbarAgentButtonSlot>
        <DocumentPreviewModeSwitch />
      </ToolbarAgentButtonSlot>
    </PreviewToolbar>
  )
}
